/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name)) : '';
};

/**
 * 格式化时间
 */
export const formatDate = (date,format) => {
    var args = {
       "M+": date.getMonth() + 1,
       "d+": date.getDate(),
       "h+": date.getHours(),
       "m+": date.getMinutes(),
       "s+": date.getSeconds(),
       "q+": Math.floor((date.getMonth() + 3) / 3),  //quarter
       "S": date.getMilliseconds()
    };
    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var i in args) {
        var n = args[i];
        if (new RegExp("(" + i + ")").test(format))
           format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ("00" + n).substr(("" + n).length));
    }
    return format;
};

/**
 * 获取表单对象只有被使用过的字段 即有设置prop属性的form-item
 * sourceForm表单对象
 * formFields 设置了prop属性的form-item字段
 * hiddenColumns 隐藏的列 需要传给表单但又不在props体现出来的特殊列，例如表单主键
 * Array.isArray(val)区分是对象或数组
 */
export const getFormData = (sourceForm,formFields,hiddenColumns) => {
    if(!formFields || formFields.length == 0){
        return false;
    }
    let result = {};
    let props = formFields.map(function(field){
		if(field.fieldValue){  //只把有值的字段传后台
			return field.prop;
		}
	});
    props.forEach(function (item) {
        if(item in sourceForm){
            if(typeof (sourceForm[item]) == 'object'){//对象或数组
                result[item] = JSON.parse(JSON.stringify(sourceForm[item]));
            }else{
                result[item] = sourceForm[item];
            }

        }
    });
    if(hiddenColumns && hiddenColumns.length > 0){
        hiddenColumns.forEach(column_name => {
            if(typeof (sourceForm[column_name]) == 'object'){//对象或数组
                result[column_name] = JSON.parse(JSON.stringify(sourceForm[column_name]));
            }else{
                result[column_name] = sourceForm[column_name];
            }
        });
    }
    return result;
};